import { useOurRollbarLog } from '@petconsole/pure-fe-utils';

const useOurError = () => {
  const { log, rollbar } = useOurRollbarLog();

  return { log, rollbar };
};

export default useOurError;
